export default __webpack_public_path__ + "static/media/employee-directory.59834754.jpg";